var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 13.4139L17.6571 19.0709C17.8457 19.2531 18.0983 19.3539 18.3605 19.3516C18.6227 19.3493 18.8735 19.2441 19.0589 19.0587C19.2443 18.8733 19.3495 18.6225 19.3517 18.3603C19.354 18.0981 19.2532 17.8455 19.0711 17.6569L13.4141 11.9999L19.0711 6.34291C19.2532 6.1543 19.354 5.9017 19.3517 5.6395C19.3495 5.37731 19.2443 5.1265 19.0589 4.94109C18.8735 4.75568 18.6227 4.65051 18.3605 4.64823C18.0983 4.64595 17.8457 4.74675 17.6571 4.92891L12.0001 10.5859L6.34307 4.92891C6.15362 4.75125 5.90248 4.65427 5.6428 4.65849C5.38311 4.6627 5.13526 4.76779 4.95168 4.9515C4.76809 5.13521 4.66319 5.38314 4.65915 5.64283C4.65512 5.90251 4.75228 6.15358 4.93007 6.34291L10.5861 11.9999L4.92907 17.6569C4.83356 17.7492 4.75738 17.8595 4.70497 17.9815C4.65256 18.1035 4.62497 18.2347 4.62382 18.3675C4.62266 18.5003 4.64796 18.632 4.69825 18.7549C4.74853 18.8778 4.82278 18.9894 4.91667 19.0833C5.01057 19.1772 5.12222 19.2514 5.24511 19.3017C5.36801 19.352 5.49969 19.3773 5.63247 19.3762C5.76525 19.375 5.89647 19.3474 6.01847 19.295C6.14048 19.2426 6.25082 19.1664 6.34307 19.0709L12.0001 13.4139Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b57dc9b30b4873085df638f411a59830.svg";
export { ForwardRef as ReactComponent };